var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EuiAlert',{attrs:{"color":_vm.alert.type,"closable":_vm.alert.type !== 'success'},on:{"click:close":_vm.closeAlert}},[_vm._v("\n    "+_vm._s(_vm.alert.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }